<template>
  <div class="app-container">
    <el-form :inline="true" ref="filterForm" :model="filter">
      <!-- <el-form-item label="关联表" prop="re_table_name">
        <el-select v-model="filter.re_table_name" placeholder="选择表" clearable>
          <el-option v-for="item in powerChargePileOptions" :key="item.ID" :label="item.name" :value="item.ID"></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="资产码">
        <el-input placeholder="输入资产码" v-model="filter.assets_code" clearable></el-input>
      </el-form-item>
      <el-form-item label="发送主题">
        <el-input placeholder="输入发送主题" v-model="filter.topic" clearable></el-input>
      </el-form-item>
      <!-- <el-form-item label="发送次数">
        <el-input placeholder="输入发送次数" v-model="filter.send_times" clearable></el-input>
      </el-form-item> -->
      <el-form-item label="时间" prop="date">
        <el-date-picker v-model="filter.date" type="datetimerange" start-placeholder="预发送时间" end-placeholder="预发送时间" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
      </el-form-item>
      <el-form-item label="指令类型">
        <el-select v-model="filter.order_type" placeholder="请选择指令类型" clearable>
          <el-option v-for="item in orderTypeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="发送状态" prop="push_state">
        <el-select filterable v-model="filter.push_state" placeholder="请选择发送状态" clearable>
          <el-option v-for="item in deliveryStatus" :key="item.ID" :label="item.name" :value="item.ID"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="指令说明">
        <el-input placeholder="输入指令说明" v-model="filter.order_remark" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="toFilter">{{ $t("publics.querybtn") }}</el-button>
        <el-button icon="el-icon-refresh" @click="toReset">{{ $t("publics.resetbtn") }}</el-button>
      </el-form-item>
    </el-form>
    <el-table header-cell-class-name="table-header-cell" :data="tableData" height="100%" v-loading="loading">
      <el-table-column label="序号" type="index" width="80"></el-table-column>
      <el-table-column label="发送主题" prop="topic" align="center"></el-table-column>
      <el-table-column label="指令类型" prop="order_type_name" align="center"></el-table-column>
      <el-table-column label="指令说明" prop="order_remark" align="center"></el-table-column>
      <el-table-column label="发送次数" prop="send_times" width="90" align="center"></el-table-column>
      <el-table-column label="发送状态" prop="push_state" width="90" align="center">
        <template slot-scope="{ row }">
          <el-tag type="warning" v-if="row.push_state == 0">未发送</el-tag>
          <el-tag type="success" v-else-if="row.push_state == 1">发送成功</el-tag>
          <el-tag type="danger" v-else>发送失败</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="预发送时间" prop="push_time" width="150"  align="center"></el-table-column>
      <el-table-column label="实发送时间" prop="run_time" width="150"  align="center"></el-table-column>
      
      
      <el-table-column label="创建时间" prop="create_time" width="150"  align="center"></el-table-column>
      <el-table-column :label="$t('publics.operation')" width="100"  align="center">
        <template slot-scope="{ row }">
          <el-button type="text" @click="onDetail(row)" v-permision_tjtf="'detail'">详情</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="my-pagination">
      <el-pagination
        background
        layout="sizes,total,prev,pager,next,jumper"
        :total="pageParams.total"
        :page-size="this.pageParams.limit"
        :page-sizes="[5, 10, 50, 100, 500, 1000]"
        :current-page="this.pageParams.page"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
    <el-dialog :visible.sync="detailVisible" title="指令发送详情" width="1200px" :close-on-click-modal="false">
      <el-row type="flex" justify="center">
        <el-col :span="20">
          <el-form label-position="right" label-width="120px" :model="detailForm" ref="detailForm">
            <el-form-item label="发送主题" prop="topic">
              <el-input v-model="detailForm.topic" readonly />
            </el-form-item>

            <el-form-item label="指令类型" prop="order_type">
              <el-input :value="formatOrderType(detailForm.order_type)" readonly />
            </el-form-item>

            <el-form-item label="发送状态" prop="push_state">
              <el-input :value="formatState(detailForm.push_state)" readonly />
            </el-form-item>

            <el-form-item label="发送次数" prop="send_times">
              <el-input v-model="detailForm.send_times" readonly />
            </el-form-item>

            <el-form-item label="预发送时间" prop="push_time">
              <el-input v-model="detailForm.push_time" readonly />
            </el-form-item>

            <el-form-item label="实发送时间" prop="run_time">
              <el-input v-model="detailForm.run_time" readonly />
            </el-form-item>

            <el-form-item label="创建时间" prop="create_time">
              <el-input v-model="detailForm.create_time" readonly />
            </el-form-item>

            <el-form-item label="关联表" prop="re_table_name">
              <el-input v-model="detailForm.re_table_name" readonly />
            </el-form-item>

            <el-form-item label="关联表编号" prop="re_table_id">
              <el-input v-model="detailForm.re_table_id" readonly />
            </el-form-item>

            <el-form-item label="指令说明" prop="order_remark">
              <el-input type="textarea" v-model="detailForm.order_remark" :rows="2" readonly />
            </el-form-item>

            <el-form-item label="发送内容" prop="order_text">
              <el-input type="textarea" v-model="detailForm.order_text" :rows="4" readonly />
            </el-form-item>

            <el-form-item label="备注" prop="remark">
              {{ detailForm.remark }}
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import pageMixin from "@/mixins/pageMixin.js"
import { GetSendOrderLogPageList } from "@/api/dev_archive"
export default {
  name: "SmsLog",
  mixins: [pageMixin],
  data() {
    return {
      deliveryStatus: [
        { ID: 0, name: "未发送" },
        { ID: 1, name: "发送成功" },
        { ID: 2, name: "发送失败" }
      ],
      orderTypeOptions: [
        { label: "JNG下发启动充电命令", value: 1 },
        { label: "响应故障上报", value: 2 },
        { label: "特殊调控指令", value: 3 },
        { label: "JNG下发停止充电命令", value: 4 },
        { label: "设备对时", value: 5 },
        { label: "站点计费模型", value: 6 },
        { label: "交易记录确认服务", value: 7 },
        { label: "参数配置", value: 8 },
        { label: "分支箱计费模型", value: 9 },
        { label: "费控表计费模型", value: 10 },
        { label: "查询费控表余额", value: 11 },
        { label: "查询sim卡信息", value: 12 },
        { label: "费控表余额充值", value: 13 },
        { label: "费控表余额强制对齐", value: 14 },
        { label: "下发费控表绑定关系", value: 15 },
        { label: "查询费控表绑定关系", value: 16 },
        { label: "费控表合闸跳闸", value: 17 },
        { label: "时段调控指令下发", value: 18 },
        { label: "设备重启", value: 19 },
        { label: "JNG下发预约启动充电命令", value: 20 },
        { label: "JNG下发智能托管启动充电命令", value: 21 },
        { label: "下发预约订单控制", value: 22 },
        { label: "充电桩计费模型", value: 23 },
        { label: "设备远程升级", value: 24 },
        { label: "招离线订单", value: 25 },
        { label: "平台发送电表底值对齐", value: 26 }
      ],
      powerChargePileOptions: {},
      filter: {
        re_table_name: "",
        assets_code: "",
        topic: "",
        date: "",
        push_state: "",
        order_type: "",
        send_times: ""
      },
      // 详情弹窗相关
      detailVisible: false,
      detailForm: {
        topic: "",
        order_type: "",
        push_state: "",
        send_times: "",
        push_time: "",
        run_time: "",
        create_time: "",
        re_table_name: "",
        re_table_id: "",
        order_remark: "",
        order_text: "",
        remark: ""
      },
      tableData: [],
      loading: false
    }
  },
  created() {
    this.getData()
  },
  methods: {
    // 状态格式化
    formatState(state) {
      const status = this.deliveryStatus.find((item) => item.ID === state)
      return status ? status.name : "未知状态"
    },

    // 指令类型格式化
    formatOrderType(orderType) {
      const option = this.orderTypeOptions.find((item) => item.value === orderType)
      return option ? option.label : orderType
    },

    // 打开详情弹窗
    onDetail(row) {
      this.detailForm = { ...row }
      this.detailVisible = true
    },

    getData() {
      let startTime = "",
        endTime = ""
      if (this.filter.date && this.filter.date.length) {
        startTime = this.filter.date[0]
        endTime = this.filter.date[1]
      }

      const params = {
        page: this.pageParams.page,
        pagesize: this.pageParams.limit,
        assets_code: this.filter.assets_code,
        topic: this.filter.topic,
        order_type: this.filter.order_type,
        send_times: this.filter.send_times,
        order_remark: this.filter.order_remark,
        push_time_start: startTime,
        push_time_end: endTime
      }

      if (this.filter.push_state !== "") {
        params.push_state = this.filter.push_state
      }

      this.loading = true
      GetSendOrderLogPageList(params)
        .then((res) => {
          this.tableData = res.data
          this.pageParams.total = res.total
        })
        .finally(() => {
          this.loading = false
        })
    },

    // 以下为分页相关方法
    handleSizeChange(val) {
      this.pageParams.limit = val
      this.getData()
    },

    handleCurrentChange(val) {
      this.pageParams.page = val
      this.getData()
    },

    toFilter() {
      this.pageParams.page = 1
      this.getData()
    },

    toReset() {
      this.$refs.filterForm.resetFields()
      this.filter = {
        re_table_name: "",
        assets_code: "",
        topic: "",
        date: "",
        push_state: "",
        order_type: "",
        send_times: ""
      }
      this.pageParams.page = 1
      this.getData()
    },

    onDelete(row) {
      // 删除操作逻辑
      this.$confirm("确认删除该记录吗？", "提示", {
        type: "warning"
      }).then(() => {
        // 调用删除API
        console.log("删除记录:", row)
      })
    }
  }
}
</script>

<style scoped>
.el-cascader-menu {
  max-width: 250px;
}
</style>
